import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class VoicemailService {
  private unreadCountSubject = new BehaviorSubject<number>(0);
  unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  get unreadCount(): number {
    return this.unreadCountSubject.value;
  }

  refreshUnreadCount(): void {
    if (!this.userService?.id) {
      this.unreadCountSubject.next(0);
      return;
    }

    this.http
      .get<any>(`${environment.api_url}/voicemail/unread_count`)
      .subscribe({
        next: (resp) => {
          this.unreadCountSubject.next(Number(resp?.count || 0));
        },
        error: () => {
          this.unreadCountSubject.next(0);
        },
      });
  }

  markAsRead(messageId: number) {
    return this.http.post<any>(`${environment.api_url}/voicemail/message/${messageId}/read`, {});
  }

  markAsUnread(messageId: number) {
    return this.http.post<any>(`${environment.api_url}/voicemail/message/${messageId}/unread`, {});
  }
}
